import React from 'react';
import { Button, Table,Card, message } from 'antd';
import { addKey, truncateText} from "../../utils/utils";
import { route } from '../../routes/routes';
import { getGroupList } from '../../model/group/requests';
import {dbFields} from '../../model/group/column';



export default class Group extends React.Component {
    constructor(props){
        super(props);
        this.state= {
            data:[]
        }
        this.columns = [
            {
                title: dbFields.id.title,
                dataIndex: dbFields.id.key,
                key: dbFields.id.key,
              },
            {
              title: dbFields.name.title,
              dataIndex: dbFields.name.key,
              key: dbFields.name.key,
            },
            {
                title: dbFields.custom.title,
                dataIndex: dbFields.custom.key,
                key: dbFields.custom.key,
                render:(text)=>{
                    let newText = text ? truncateText(text,50) : text
                    return (
                        <>
                            {newText}
                        </>
                    )
                }
              },
              {
                title: dbFields.role.title,
                dataIndex: dbFields.role.key,
                key: dbFields.role.key,
              },
            {
                title: 'Action',
                dataIndex: '1',
                key: 'action',
                render:(text,record)=>
                    
                        <>
                            <Button
                            shape="round"
                            style={{background: "#851dd6",color:"white" }}
                                type='default' onClick={this.btnFn.bind(this,record)} >
                            Edit
                            </Button>
                          
                            <Button
                                shape="round"
                                style={{background: "#851dd6",color:"white" }}
                                type='default' onClick={this.BindCustom.bind(this,record)} 
                                // just for adminstractor
                                disabled = {( record.parent_id ===0 ? false : true )}
                                hidden = {( record.parent_id === 0 ? false : true )}
                            >
                                BindCustom
                            </Button>

                            <Button
                                shape="round"
                                style={{background: "#851dd6",color:"white" }}
                                type='default' onClick={this.BindRole.bind(this,record)} 
                            >
                                BindRole
                            </Button>
                        </>
             
            }
        ]
    }

    componentDidMount(){
        let groupList = [];
        getGroupList().then(res => {
            if(res.data.code == 200){
                groupList = addKey(res.data.data)
                for(let i=0;i<groupList.length;i++){
                    let customs = groupList[i].customs
                    let roles = groupList[i].roles
                    if(customs.length > 0){
                        let custom = ""
                        for(let j=0;j<customs.length;j++){
                            custom += customs[j].name
                            custom += ";"
                        }

                        groupList[i]["custom"] = custom.replace(/^;|;$/g, '')
                    }

                    if(roles.length > 0){
                        let role = ""
                        for(let j=0;j<roles.length;j++){
                            role += roles[j].name
                            role += ";"
                        }

                        groupList[i]["role"] = role.replace(/^;|;$/g, '')
                    }

                }
                this.setState({
                    data:groupList,
                    isLoaded:true,
                })
            }else{
                message.warning(res.data.msg)
            }
        }).catch(err=>{
            message.error(err)
        })
    }

    handlerCreate = (e)=>{
        this.props.history.push(route.group.create)
    }
    BindRole = record => {
        this.props.history.push(route.group.role + record.id);
    }
    btnFn = record => {
        this.props.history.push(route.group.edit + record.id);
    };
    BindCustom = record => {
        this.props.history.push(route.group.custom + record.id);
    }


    render(){
        return (
            <>
                <Card>
                    <Button
                     style={{background: "#851dd6",color:"white" }}
                     onClick={this.handlerCreate}>Create</Button>
                </Card>
                <Table 
                     dataSource={ this.state.isLoaded ? this.state.data : [] }
                     columns={this.columns} 
                 />

            </>
        )
    }


}